const mutations = {
  SET_SETTING_BUTTON_VISIBLE(state, { isSettingButtonVisible }) {
    state.isSettingButtonVisible = isSettingButtonVisible
  },
  SET_ACCOUNT_SETTING_BUTTON_VISIBLE(state, { isAccountSettingButtonVisible }) {
    state.isAccountSettingButtonVisible = isAccountSettingButtonVisible
  },
  SET_IO_SELECT_BUTTON_VISIBLE(state, { isIOSelectButtonVisible }) {
    state.isIOSelectButtonVisible = isIOSelectButtonVisible
  },
  SET_ADV_SELECT_BUTTON_VISIBLE(state, { isAdvSelectButtonVisible }) {
    state.isAdvSelectButtonVisible = isAdvSelectButtonVisible
  },
  SET_NOTIFICATION_BUTTON_VISIBLE(state, { isNotificationButtonVisible }) {
    state.isNotificationButtonVisible = isNotificationButtonVisible
  },
}

export default mutations
